import { c as _c } from "react/compiler-runtime";
/** biome-ignore-all lint/suspicious/noArrayIndexKey: Key can be null in document also the text is maybe not unique */
import { BodyLong, Heading, Link, Tag } from "@navikt/ds-react";
import { ComponentHeader } from "@/components/header/ComponentHeader";
import { useFerdigstillForhandsVarsel } from "@/data/ferdigstillVarsel";
import type { AktivitetskravVurdering } from "@/schema/aktivitetskravVurderingSchema";
import { getShortDateFormat } from "@/utils/dateUtils";
import { AlertForUsersAffectedByNoNotificationsBug } from "./alertForUsersAffectedByNoNotificationsBug/AlertForUsersAffectedByNoNotificationsBug";
interface Props {
  vurdering: AktivitetskravVurdering;
}
export const ForhandsvarselComponent = t0 => {
  const $ = _c(15);
  const {
    vurdering
  } = t0;
  useFerdigstillForhandsVarsel();
  if (vurdering.status !== "FORHANDSVARSEL") {
    return null;
  }
  let t1;
  if ($[0] !== vurdering) {
    t1 = <AlertForUsersAffectedByNoNotificationsBug forhandsvarselVurdering={vurdering} />;
    $[0] = vurdering;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== vurdering.document || $[3] !== vurdering.sistVurdert) {
    t2 = vurdering.document?.map((d, index) => {
      switch (d.type) {
        case "HEADER_H1":
          {
            return <div className="mt-4" key={index}>{d.texts.map((text_4, index_5) => <ComponentHeader key={index_5} headerText={text_4} utsendtDato={vurdering.sistVurdert} alertStyle="warning" />)}</div>;
          }
        case "HEADER_H2":
          {
            return <div className="mt-4" key={index}>{d.texts.map(_temp)}</div>;
          }
        case "HEADER_H3":
          {
            return <div className="mt-4" key={index}>{d.texts.map(_temp2)}</div>;
          }
        case "LINK":
          {
            return <div key={index}>{d.title && <Heading size="xsmall" level="3" spacing={true}>{d.title}</Heading>}{d.texts.map(_temp3)}</div>;
          }
        case "BULLET_POINTS":
          {
            return <ul className="list-disc list-outside ml-5" key={index}>{d.texts.map(_temp4)}</ul>;
          }
        case "PARAGRAPH":
          {
            return <div key={index}>{d.texts.map(_temp5)}</div>;
          }
        default:
          {
            const _exhaustive = d.type;
            return _exhaustive;
          }
      }
    });
    $[2] = vurdering.document;
    $[3] = vurdering.sistVurdert;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex flex-col gap-4 mb-4">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== vurdering.fristDato) {
    t4 = getShortDateFormat(vurdering.fristDato);
    $[7] = vurdering.fristDato;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <Tag variant="warning-moderate" className="w-fit mt-4">Svarfrist: {t4}</Tag>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t5) {
    t6 = <div>{t1}{t3}{t5}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(text_3, index_4) {
  return <Heading size="large" level="2" key={index_4}>{text_3}</Heading>;
}
function _temp2(text_2, index_3) {
  return <Heading size="medium" level="2" key={index_3}>{text_2}</Heading>;
}
function _temp3(text_1, index_2) {
  return <Link className="break-normal" key={index_2} href={text_1}>{text_1}</Link>;
}
function _temp4(text_0, index_1) {
  return <BodyLong size="small" key={index_1} as="li">{text_0}</BodyLong>;
}
function _temp5(text, index_0) {
  return <BodyLong size="small" key={index_0}>{text}</BodyLong>;
}